import type { GQL } from "@binale-tech/shared";
import React, { type FC, memo, useCallback } from "react";

import { FinApiBankImportForm } from "@banks/features/transactions/components/BankTransactionsToolbar/components/FinApiBankImportForm";

import type { AgentPanelProps } from "./agentPanels";

const BankImportAgentPanelImpl: FC<AgentPanelProps> = ({ panel, onDone }) => {
    const onImported = panel.type === "bankImport" ? panel.onImported : undefined;
    const handleFinished = useCallback(
        (result: GQL.IFinApiTransactionsImportResponse) => {
            onImported?.(result.transactionsCount ?? null);
            onDone("done");
        },
        [onImported, onDone],
    );
    if (panel.type !== "bankImport") return null;
    return <FinApiBankImportForm bankId={panel.bankId} variant="inline" onFinished={handleFinished} />;
};

export const BankImportAgentPanel = memo(BankImportAgentPanelImpl);
